import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CmsContentPipe, CmsMultiContent } from '@domgen/dgx-fe-cms';
import { TextAlign } from '@domgen/dgx-fe-common';
import { Content, ContentComponent } from '@domgen/dgx-fe-components/content';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { ContactUsPanel } from '@support/util-models';
import { ContactUsPanelComponent } from '../contact-us-panel/contact-us-panel.component';

@Component({
  selector: 'support-contact-us-panel-block',
  templateUrl: './contact-us-panel-block.component.html',
  styleUrls: ['./contact-us-panel-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CmsContentPipe,
    ContactUsPanelComponent,
    ContentComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgFor,
  ],
})
export class ContactUsPanelBlockComponent implements Content {
  @Input() body?: string;
  @Input() intro?: string;
  @Input() panels: CmsMultiContent<ContactUsPanel> = {};
  @Input() textAlign: TextAlign = 'center';
  @Input() title?: string;
}
